import { useQuery } from '@tanstack/react-query';

import { toPromoBrand } from '~/consts/promoBrand';

import { CheckVoucherCodeQuery, checkVoucherCode } from '~/services/PromoService';

export const voucherCheckQueryKeys = {
  all: ['voucher-check'] as const,
  detail: (query: Pick<CheckVoucherCodeQuery, 'voucherName'> & Partial<CheckVoucherCodeQuery>) =>
    [...voucherCheckQueryKeys.all, query] as const,
};

type UseVoucherCheckParams = {
  voucherName: string | undefined;
  brand?: string;
  presentationType?: CheckVoucherCodeQuery['presentationType'];
  includeCounts?: boolean;
  countsSinceHours?: number;
};

export function useVoucherCheck({
  voucherName,
  brand,
  presentationType,
  includeCounts = true,
  countsSinceHours,
}: UseVoucherCheckParams) {
  const trimmedName = voucherName?.trim() ?? '';

  return useQuery({
    queryKey: voucherCheckQueryKeys.detail({
      voucherName: trimmedName,
      ...(brand ? { brand: toPromoBrand(brand) } : {}),
      presentationType,
      includeCounts,
      countsSinceHours,
    }),
    queryFn: async ({ signal }) => {
      return await checkVoucherCode(
        {
          voucherName: trimmedName,
          ...(brand ? { brand: toPromoBrand(brand) } : {}),
          ...(presentationType !== undefined ? { presentationType } : {}),
          ...(includeCounts ? { includeCounts: true } : {}),
          ...(countsSinceHours !== undefined ? { countsSinceHours } : {}),
        },
        { signal },
      );
    },
    enabled: trimmedName.length > 0,
  });
}
